import { z } from 'zod';

/**
 * Jedan oblik greške za cijeli sustav. `code` je stabilan i klijent na njemu
 * bira poruku iz packages/i18n — nikad ne prikazuje sirovi tekst servera.
 */
export const errorCodes = [
  'bad_request',
  'validation_failed',
  'unauthorized',
  'session_expired',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'payment_required',
  'subscription_inactive',
  'upload_failed',
  'internal',
] as const;
export type ErrorCode = (typeof errorCodes)[number];

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(errorCodes),
    message: z.string(),
    fields: z.record(z.string(), z.string()).optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const httpStatusByCode: Record<ErrorCode, number> = {
  bad_request: 400,
  validation_failed: 422,
  unauthorized: 401,
  session_expired: 401,
  forbidden: 403,
  not_found: 404,
  conflict: 409,
  rate_limited: 429,
  payment_required: 402,
  subscription_inactive: 402,
  upload_failed: 400,
  internal: 500,
};

export class AppError extends Error {
  constructor(
    readonly code: ErrorCode,
    message?: string,
    readonly fields?: Record<string, string>,
  ) {
    super(message ?? code);
    this.name = 'AppError';
  }
  get status(): number {
    return httpStatusByCode[this.code];
  }
}
